import { Dispatch, SetStateAction, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import useRoutes from './useRoutes';
import { GlobalLocationStateType } from '../types/types';

/*Close expanded row when entering multiselect mode*/
export const useMasterGridMultiselectModeChecker = (
  expandedRow: any,
  selectedRows: any[],
  datasetId: string | undefined,
  setExpandedRow: Dispatch<SetStateAction<any>>
) => {
  const { pathname } = useLocation<GlobalLocationStateType>();
  const history = useHistory();
  const routes = useRoutes();

  useEffect(() => {
    // Check for master grid multiselect mode
    if (
      datasetId &&
      pathname.includes(routes.datasetList(datasetId)) &&
      pathname.includes('item') &&
      !pathname.includes('/form/') &&
      selectedRows.length > 0 &&
      expandedRow !== null
    ) {
      setExpandedRow(null);
      history.replace(routes.datasetList(datasetId));
    }
  }, [pathname, selectedRows, expandedRow, datasetId]);
};
